import React, { useEffect, useState } from 'react'

import { useLocation } from '@reach/router'
import type { Heading } from '@src/Application/Interfaces/Features/BlogDetails/utils'
import { useScrollPosition } from '@src/Application/Interfaces/Hooks/useScrollPosition/useScrollPosition'
import { useTranslation } from '@src/Application/Interfaces/Hooks/useTranslation'
import { Nullable } from '@src/Application/Types/Opt'
import { getDOMIdFromString } from '@src/Infrastructure/Url/getDomIdFromString'

import { Link, List, ListItem, SubLink, Title, Wrapper } from './ContentGuide.styled'
import { buildUrl, getFirstVisibleSection } from './utils'

type ContentGuideType = {
    items: Heading[]
    showContentGuideSubmenu: boolean
}

const ContentGuide = (props: ContentGuideType): Nullable<JSX.Element> => {
    const { items, showContentGuideSubmenu = true } = props
    const { t } = useTranslation()
    const [selected, setSelected] = useState<string>()
    const location = useLocation()

    const defaultAggr: string[] = []
    const ids = items.reduce((aggr, item) => {
        aggr.push(getDOMIdFromString(item.title))

        return aggr
    }, defaultAggr)

    useEffect(getFirstVisibleSection(ids, setSelected), [])
    useScrollPosition(getFirstVisibleSection(ids, setSelected))

    if (!items || !items.length) {
        return null
    }

    return (
        <Wrapper>
            <Title>{t('contentGuide')}</Title>
            <List>
                {items.map((item: Heading, i: number) => {
                    const id = getDOMIdFromString(item.title)
                    const showSubheadings = item.subHeadings && showContentGuideSubmenu

                    return (
                        <ListItem key={id}>
                            <Link
                                to={buildUrl(location.pathname, id, process.env.GATSBY_PATH_PREFIX)}
                                $selected={selected === id}
                            >
                                {i + 1}. <span dangerouslySetInnerHTML={{ __html: item.title }}></span>
                            </Link>
                            {showSubheadings &&
                                item.subHeadings.map((h) => {
                                    const subId = getDOMIdFromString(h)
                                    return (
                                        <SubLink
                                            key={subId}
                                            to={buildUrl(location.pathname, subId, process.env.GATSBY_PATH_PREFIX)}
                                        >
                                            {h}
                                        </SubLink>
                                    )
                                })}
                        </ListItem>
                    )
                })}
            </List>
        </Wrapper>
    )
}

export { ContentGuide, getFirstVisibleSection }
